import template from './dashboard-number-filter.component.html';
import type { InteractiveFilter } from '../../InteractiveFilter.model';
import type { IComponentController } from 'angular';
import type { I18n } from '../../../i18n/mx-internationalization';

export class DashboardNumberFilterController implements IComponentController {
	filter!: InteractiveFilter;

	private _valueFrom?: number;
	private _valueTo?: number;

	static readonly $inject = ['mx.internationalization'];
	constructor(private readonly i18n: I18n) {}

	$onInit() {
		this.handleExternalChanges();
		this.updateFilterValue();

		if (Array.isArray(this.filter.value)) {
			const [from, to] = this.filter.value;
			this._valueFrom = typeof from === 'number' ? from : undefined;
			this._valueTo = typeof to === 'number' ? to : undefined;

			this.updateFilterValue();
		}

		this.filter.onChange(() => {
			this.handleExternalChanges();
		});
	}

	private handleExternalChanges() {
		this._valueFrom = undefined;
		this._valueTo = undefined;

		if (Array.isArray(this.filter.value)) {
			const [from, to] = this.filter.value;
			this._valueFrom = typeof from === 'number' ? from : undefined;
			this._valueTo = typeof to === 'number' ? to : undefined;
		}
	}

	get valueFrom() {
		return this._valueFrom;
	}

	set valueFrom(newValue: number | undefined) {
		this._valueFrom = newValue;
		this.updateFilterValue();
	}

	get valueTo() {
		return this._valueTo;
	}

	set valueTo(newValue: number | undefined) {
		this._valueTo = newValue;
		this.updateFilterValue();
	}

	updateFilterValue() {
		if (typeof this._valueFrom !== 'number' && typeof this._valueTo !== 'number') {
			this.filter.clear();
			return;
		}

		const value = [this._valueFrom, ...(typeof this._valueTo === 'number' ? [this._valueTo] : [])];
		this.filter.setValue(value, this.filter.operators.Between.getFullLabel(this.filter.title, [this._valueFrom ?? '', this._valueTo ?? '']));
	}
}

export const DashboardNumberFilterComponent = {
	name: 'mxDashboardNumberFilter',
	controller: DashboardNumberFilterController,
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
